import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex-direction: row;
`;
export const ButtonLinkContainer = styled.TouchableOpacity`
  border-style: solid;
  border-color: ${({theme}) => theme.colors.blue};
  border-bottom-width: 2px;
  align-items: center;
  flex-direction: row;
`;
export const ButtonLinkText = styled.Text`
  color: ${({theme}) => theme.colors.blue};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
`;
